import { render, staticRenderFns } from "./BlockListRowItem.vue?vue&type=template&id=35c936b6&scoped=true"
import script from "./BlockListRowItem.vue?vue&type=script&lang=js"
export * from "./BlockListRowItem.vue?vue&type=script&lang=js"
import style0 from "./BlockListRowItem.vue?vue&type=style&index=0&id=35c936b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c936b6",
  null
  
)

export default component.exports